import React from 'react'
import type { ValueStringProps as StringValueProps } from '../String'
import StringValue from '../String'
import useTranslation from '../../hooks/useTranslation'
import { useValueProps } from '../../hooks'
import withComponentMarkers from '../../../../shared/helpers/withComponentMarkers'

export type ValuePostalCodeAndCityProps = StringValueProps &
  Partial<Record<'postalCode' | 'city', StringValueProps>>

function PostalCodeAndCity(props: ValuePostalCodeAndCityProps) {
  const translations = useTranslation().PostalCodeAndCity

  const cityValue = useValueProps(props?.city || {}).value ?? props.value
  const postalCodeValue =
    useValueProps(props?.postalCode || {}).value ?? props.value

  const value =
    props.value ??
    ((postalCodeValue || cityValue
      ? [postalCodeValue, cityValue].filter(Boolean).join(' ')
      : undefined) ||
      undefined)

  const label =
    props.label ?? (props.inline ? undefined : translations.label)

  const stringValueProps: ValuePostalCodeAndCityProps = {
    ...props,
    value,
    label,
  }

  return <StringValue {...stringValueProps} />
}

withComponentMarkers(PostalCodeAndCity, {
  _supportsSpacingProps: true,
})

export default PostalCodeAndCity
